import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class Jobcategories extends Component {
    render() {
        return (
            <div className="row sp20">
                <div className="col-lg-3 col-md-6 col-sm-6">
                    <Link to={"/remote-jobs-backend"} className="dez-tilte">
                        <div className="icon-bx-wraper">
                            <div className="icon-content">
                                <div className="icon-md text-primary m-b20"><i className="ti-settings"></i></div>
                                <span className="dez-tilte">Backend Jobs</span>
                                <p className="m-a0">&nbsp;</p>
                                <div className="rotate-icon"><i className="ti-settings"></i></div> 
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6">
                    <Link to={"/remote-jobs-frontend"} className="dez-tilte">
                        <div className="icon-bx-wraper">
                            <div className="icon-content">
                                <div className="icon-md text-primary m-b20"><i className="ti-desktop"></i></div>
                                <span className="dez-tilte">Frontend Jobs</span>
                                <p className="m-a0">&nbsp;</p>
                                <div className="rotate-icon"><i className="ti-desktop"></i></div> 
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6">
                    <Link to={"/remote-jobs-devops"} className="dez-tilte">
                        <div className="icon-bx-wraper">
                            <div className="icon-content">
                                <div className="icon-md text-primary m-b20"><i className="ti-panel"></i></div>
                                <span className="dez-tilte">DevOps Jobs</span>
                                <p className="m-a0">&nbsp;</p>
                                <div className="rotate-icon"><i className="ti-panel"></i></div> 
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6">
                    <Link to={"/remote-jobs-marketing"} className="dez-tilte">
                        <div className="icon-bx-wraper">
                            <div className="icon-content">
                                <div className="icon-md text-primary m-b20"><i className="ti-bar-chart"></i></div>
                                <span className="dez-tilte">Marketing Jobs</span>
                                <p className="m-a0">&nbsp;</p>
                                <div className="rotate-icon"><i className="ti-bar-chart"></i></div> 
                            </div>
                        </div>
                    </Link>
                </div>
                <div className="col-lg-12 m-t30 m-b20">
                    <div className="section-head text-center">
                        <h3 className="m-b10">Most Popular Job Searches</h3>
                        <div className="job-tags-container" style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            gap: "10px",
                            margin: "20px 0"
                        }}>
                            <Link to="/jobs-software-engineer">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>Software Engineer</span>
                            </Link>
                            <a href="/jobs?title=UI/UX">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>UX/UI Designer</span>
                            </a>
                            <a href="/jobs?title=Product%20Manager">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>Product Manager</span>
                            </a>
                            <a href="/jobs?title=Data%20Scientist">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>Data Scientist</span>
                            </a>
                            <a href="/jobs?title=Content%20Writer">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>Content Writer</span>
                            </a>
                            <Link to="/jobs-customer-success">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>Customer Success</span>
                            </Link>
                            <a href="/jobs?title=DevOps%20Engineer">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>DevOps Engineer</span>
                            </a>
                            <Link to="/jobs-sales">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>Sales</span>
                            </Link>
                            <Link to="/jobs-marketing">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>Marketing Specialist</span>
                            </Link>
                            <Link to="/jobs-account-executive">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>Account Executive</span>
                            </Link>
                            <Link to="/jobs-backend">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>Backend Developer</span>
                            </Link>
                            <Link to="/jobs-frontend">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>Frontend Developer</span>
                            </Link>
                            <Link to="/jobs-fullstack">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>FullStack Developer</span>
                            </Link>
                            <a href="/jobs?title=Recruiter">
                                <span className="job-tag" style={{
                                    padding: "8px 15px",
                                    background: "#f0f5ff",
                                    color: "#2e55fa",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    display: "inline-block",
                                    transition: "all 0.3s",
                                    fontWeight: "500",
                                    border: "1px solid #e0e9ff"
                                }}>Recruiter</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 text-center m-t10" style={{display: ""}}>
                    <Link to={"/all-jobs-by-category"} className="dez-tilte">
                        <button className="site-button radius-l button-lg" style={{
                            transition: "all 0.3s ease",
                            padding: "12px 25px"
                        }}>
                            Explore All Categories <i className="ti-arrow-right" style={{
                                marginLeft: "8px",
                                transition: "transform 0.3s ease"
                            }}></i>
                        </button>
                    </Link>
                </div>
            </div>
        );
    }
};

export default Jobcategories;
